import { PlanPeriodDto, getActivePlanPeriod } from 'core/application/adminDashboard/benefitDetails/benefitPlanPeriods'

import useQueryRequest, { SendQueryRequestOptions } from './useQueryRequest'

type Response = PlanPeriodDto | null

const useActivePlanPeriod = (): [
  Response,
  boolean,
  (func: () => Promise<Response>, opts?: SendQueryRequestOptions) => Promise<Response>,
  () => Promise<Response>,
  boolean,
] => {
  return useQueryRequest<Response>(null, () => getActivePlanPeriod())
}

export default useActivePlanPeriod
